




























































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { QInfiniteScroll, debounce, scroll } from 'quasar'
import store from 'src/assets/store'
import dateShort from 'src/assets/dateShort'
import ExpandablePreview from 'components/ExpandablePreview.vue'
import TopicButtonSettings from 'src/components/presenter/item/forum/TopicButtonSettings.vue'
import PostButtonAdd from 'components/presenter/item/forum/PostButtonAdd.vue'
import PostButtonReply from 'components/presenter/item/forum/PostButtonReply.vue'
import PostButtonEdit from 'components/presenter/item/forum/PostButtonEdit.vue'
import PostButtonHide from 'components/presenter/item/forum/PostButtonHide.vue'
import MarkdownViewer from 'components/MarkdownViewer.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import api from 'src/assets/api/gql'
import ForumPersonActivityUpdate from 'src/graphql/forum_person_activity/ForumPersonActivityUpdate.gql'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    PostButtonAdd,
    ExpandablePreview,
    TopicButtonSettings,
    PostButtonReply,
    PostButtonEdit,
    PostButtonHide,
    MarkdownViewer,
    PersonAvatar
  }
})
export default class ItemForumTopic extends Vue {
  dateShort = dateShort
  me = store.state.person
  loading = true
  ready = false
  bottom = false
  postsLoadChunkSize = 25
  postsLoadNextInterval = 0
  postsLoadNextIntervalTime = 5 * 60 * 1000
  posts: ForumTopicPost[] = []
  authors: Json = {}
  totalPosts = 0
  lastPostRead = 0
  lastPostShown = 0

  @Prop()
  readonly topic!: ForumTopic

  @Prop()
  readonly query!: string

  @Prop({ default: false })
  readonly canAuthEdit!: Boolean

  @Prop({ default: false })
  readonly readonly!: Boolean

  @Ref()
  readonly loader!: QInfiniteScroll

  @Ref()
  readonly scrollBottom!: HTMLElement

  get postsLoaded () {
    return this.topic.reverse ? [...this.posts].reverse() : this.posts
  }

  @Watch('lastPostShown')
  async saveLastPostRead (lastPostShown: number) {
    if (lastPostShown > this.lastPostRead) {
      await api.mutate({
        query: ForumPersonActivityUpdate,
        variables: {
          forumTopicId: this.topic.id,
          lastPostId: lastPostShown
        }
      })
    }
  }

  craeted () {
    this.saveLastPostRead = debounce(this.saveLastPostRead, 1000)
  }

  beforeDestroy () {
    this.postsLoadNextInterval && clearInterval(this.postsLoadNextInterval)
  }

  async refresh () {
    this.postsLoadNextInterval && clearInterval(this.postsLoadNextInterval)
    this.posts = []
    this.authors = []
    this.loading = true
    this.ready = true
    this.loader.resume()
    this.loader.poll()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const firstPostId = this.posts.length ? this.posts[ 0 ].id : null
    const id = this.topic.id
    const count = firstPostId ? Math.min(this.postsLoadChunkSize, firstPostId - 1) : this.postsLoadChunkSize
    const start = firstPostId ? Math.max(0, firstPostId - count - 1) : -1
    const { data } = await api.query({
      query: this.query,
      variables: { id, start, count }
    })
    this.loading = false
    const response = (data.forumTopic || data.attendeeForumTopics?.nodes[0])
    if (response) {
      Object.assign(this.authors, response.posts.authors || {})
      this.posts.unshift(...response.posts.posts || [])
      this.totalPosts = response.totalPosts || 0
      this.lastPostRead = response.totalPostsPersonRead || 0
      done(!response.posts.posts || response.posts.posts.length === 0 || response.posts.posts[0].id === 1)
      if (start === -1) {
        this.postsLoadNextInterval = window.setInterval(this.loadNext, this.postsLoadNextIntervalTime)
        if (!this.topic.reverse && this.posts.length) {
          this.$nextTick(() => {
            const { getScrollTarget, setScrollPosition } = scroll
            const target = getScrollTarget(this.scrollBottom)
            const offset = this.scrollBottom.offsetTop
            const duration = 1000
            setScrollPosition(target, offset, duration)
          })
        }
      }
    } else {
      done(true)
    }
  }

  async loadNext () {
    const lastPostId = this.posts.length ? this.posts[ this.posts.length - 1 ].id : null
    const id = this.topic.id
    const count = this.postsLoadChunkSize
    const start = lastPostId || 0
    const { data } = await api.query({
      query: this.query,
      variables: { id, start, count }
    })
    const response = (data.forumTopic || data.attendeeForumTopics?.nodes[0])
    if (response) {
      Object.assign(this.authors, response.posts.authors || {})
      this.posts.push(...response.posts.posts || [])
    }
  }

  setLastPostShown (e: IntersectionObserverEntry, lastPostShown: number) {
    if (e.isIntersecting) {
      this.lastPostShown = Math.max(this.lastPostShown, lastPostShown)
    }
  }

  setBottom (e: IntersectionObserverEntry) {
    this.bottom = e.isIntersecting
  }
}
